module.exports = __webpack_public_path__ + "static/media/logo_CIM_rc.95a13f7e.svg";